class Map {

    constructor(mapElement, options = {}) {
        this.bounds = null;
        this.mapMarkers = [];
        this.mapElement = mapElement;

        //Google maps wont clear markers if saved in instance property, so we're using a static property and trying to create a semi unique id to avoid collisions
        this.markerId = "rsl_markers_" + Math.floor(Math.random() * 1000),
        this.mapRef = new google.maps.Map(mapElement, {
            zoom: options.zoom || 6,
            center: options.center || null,
            mapTypeControl: options.mapTypeControl || false,
            streetViewControl: options.streetViewControl || false,
            mapTypeControlOptions: options.mapTypeControlOptions || {
                mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain", "rsl_style"],
            }
        });

        this.mapRef.mapTypes.set("rsl_style", this.mapStyles());
        this.mapRef.setMapTypeId("rsl_style");
        this.mapRefInfoWindow = new google.maps.InfoWindow({content: "", disableAutoPan: true});
    }

    /**
     * Gets array of Google Map Markers built from requested data
     * @param {Boolean} autofocusOnMap
     * @returns {Array<Marker>}
     */
    setMarkers(dataModel, autofocusOnMap = true) {
        if (!dataModel) return;

        this.bounds = new google.maps.LatLngBounds();

        this.mapMarkers = dataModel.map((modal) => this.buildMarker(modal));

        if (autofocusOnMap) {
            this.mapRef.fitBounds(this.bounds);
        }
    }

    /**
     * Builds map markers
     * @returns { Marker }
     */
    buildMarker(markerData) {
        const position = { lat: parseFloat(markerData?.latitude), lng: parseFloat(markerData?.longitude) };
      
        let icon = "/wp-content/themes/pegasus/assets/img/icons/map-pin.svg";
      
        const pinIcon = new google.maps.MarkerImage(
            icon,
            null, /* size is determined at runtime */
            null, /* origin is 0,0 */
            null, /* anchor is bottom center of the scaled image */
            new google.maps.Size(8, 8)
        );
      
        const marker = new google.maps.Marker({
            position: position,
            icon: pinIcon,
            map: this.mapRef,
        });

        marker.set("id", 'marker-' + markerData.latitude + '-' + markerData.longitude);

        const addressList = document.querySelectorAll('.Google-Map__address');
        const markers = []; // Create an array to store the markers

        // Get all latitudes from addressList
        const addressListLatitudes = Array.from(addressList).map(address => address.dataset.latitude);

        marker.addListener('click', () => {
            const markerID = `marker-${markerData.latitude}-${markerData.longitude}`;
            const scrollTargetID = `location-${markerData.latitude}-${markerData.longitude}`;
            const scrollTarget = document.getElementById(scrollTargetID);

            if (scrollTarget) {
                // Remove active class from all and add to the clicked one
                document.querySelectorAll('.office-location').forEach(el => {
                    el.classList.remove('Google-Map__address--active');
                });
                scrollTarget.classList.add('Google-Map__address--active');

                // Scroll to the element smoothly
                const headerOffset = 100; // Adjust this value as needed (e.g., 80, 120)
                const elementPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });

            }

            // Dispatch custom event if needed elsewhere
            const event = new CustomEvent("markerClick", {
                bubbles: true,
                detail: { markerID }
            });
            this.mapElement.dispatchEvent(event);
        });

        // Store all markers in the markers array with their latitude
        this.mapMarkers.forEach(marker => {
            markers.push({ marker, latitude: markerData.latitude });
        });

      
        // add marker to bounds so map can be centered around these points
        if (this.bounds) {
            this.bounds.extend(position);
        }
      
        return marker;
    }

    /**
     * Recenter map to a given lat/lng
     * @param {{ lat: number, lng: number }} center
     */
    setMyCenter(center) {
        return new Promise((resolve, reject) => {
            if (this.mapRef && center?.lat && center?.lng) {

                console.log("Centering map to: ", center);
                google.maps.event.trigger(this.mapRef, 'resize');
                this.mapRef.setCenter(center);
                setTimeout(() => {
                    resolve();
                }, 100);
            } else {
                reject(new Error("Map reference is not available"));
            }
        });
    }

    setZoom(zoom = 2) {
        if (zoom) {
            this.mapRef.setZoom(zoom);
        }
    }

    /**
     * Filter and display only markers from a given region
     * @param {String} region
     * @param {Array} allLocations
     */
    filterMarkersByRegion(region, allLocations, autofocus = true) {
        if (region === 'All') {
            this.setMarkers(allLocations, autofocus);
            return;
        }

        const regionLower = region.toLowerCase();

        let filtered = allLocations.filter(loc => loc.region.toLowerCase() === regionLower);

        this.setMarkers(filtered, autofocus);
    }

    /**
     * Add Google Maps event listener
     */
    addMapEventListener(event, callback) {
        google.maps.event.addListener(this.mapRef, event, callback);
    }
  

    /**
     * Generates custom map styles
     */
    mapStyles() {
        return new google.maps.StyledMapType([
            {
                // Hide all features by default
                "elementType": "all",
                "stylers": [
                    { "visibility": "off" }
                ]
            },
            {
                // Set water/ocean color
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    { "visibility": "on" },
                    { "color": "#F7F0EB" },
                    { "lightness": 0 }
                ]
            },
            {
                // Add white fill for water edges
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    { "visibility": "off" }
                ]
            },
            {
                // Set land color with a slight border effect
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    { "visibility": "on" },
                    { "color": "#D9CEC6" },
                    { "weight": 1 }
                ]
            },
            {
                // Add white country borders
                "featureType": "administrative.country",
                "elementType": "geometry.stroke",
                "stylers": [
                    { "visibility": "on" },
                    { "color": "#FFFFFF" },
                    { "weight": 1 }
                ]
            }
        ]);
    }

}

export { Map };